<div class="mat-elevation-z3 p-24 mr-24 mb-24 criteria-wrapper">
  <div class="criteria-settings-form" [formGroup]="criteriaForm">
    <div class="title-header">
      <mat-form-field floatLabel="always" class="criteria-input">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title">
      </mat-form-field>
      <div class="delete-link" [hidden]="!deleteEnabled" (click)="deleteCriteria()">
        <mat-icon>delete</mat-icon>
      </div>
    </div>
    <div class="criteria-header">
      <mat-form-field appearance="outline" floatLabel="always" class="criteria-input">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" cdkTextareaAutosize></textarea>
      </mat-form-field>
    </div>
  </div>
</div>
